module.exports = __webpack_public_path__ + "img/open-bid-end.0f11f565.png";